"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _reactTinymce = _interopRequireDefault(require("react-tinymce"));

var _leadFlows = require("tinymce-config/configs/lead-flows");

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

var _TextEditorUtils = require("lead-flows-ui/utils/TextEditorUtils");

var _makeAsyncEmojiPickerContent = _interopRequireDefault(require("ui-addon-emoji-picker/picker/makeAsyncEmojiPickerContent"));

var AsyncEmojiPicker = (0, _makeAsyncEmojiPickerContent.default)(function () {
  return import(
  /* webpackChunkName: "emoji-picker" */
  'ui-addon-emoji-picker/picker/EmojiPickerContent');
});
var MIN_HEIGHT = 105;
var THRESHOLD_HEIGHT = 260;

var RichTextEditor =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(RichTextEditor, _Component);
  (0, _createClass2.default)(RichTextEditor, null, [{
    key: "propTypes",
    get: function get() {
      return {
        contents: _react.PropTypes.string.isRequired,
        disabled: _react.PropTypes.bool,
        gates: _react.PropTypes.array,
        scopes: _react.PropTypes.array,
        id: _react.PropTypes.string.isRequired,
        isEmail: _react.PropTypes.bool,
        onBlur: _react.PropTypes.func,
        onChange: _react.PropTypes.func.isRequired,
        className: _react.PropTypes.string
      };
    }
  }]);

  function RichTextEditor(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RichTextEditor);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RichTextEditor).call(this, props));
    _this.state = {
      contents: props.contents
    };
    _this.handleEditorChange = _this.handleEditorChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.getIframe = _this.getIframe.bind((0, _assertThisInitialized2.default)(_this));
    _this.setIframeStyles = _this.setIframeStyles.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(RichTextEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var iframe = this.getIframe();
      iframe.setAttribute('scrolling', 'no');
      this.setIframeStyles();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "getIframe",
    value: function getIframe() {
      var id = this.props.id;
      return document.querySelector("#" + id + " iframe");
    }
  }, {
    key: "handleEditorChange",
    value: function handleEditorChange(editor) {
      var _this2 = this;

      var isEmail = this.props.isEmail;
      var plainText = editor.getContent({
        format: 'text'
      });
      var html = isEmail ? (0, _TextEditorUtils.convertEmptySpaces)(editor.getContent()) : editor.getContent();
      this.setState({
        contents: html
      }, function () {
        _this2.setIframeStyles();

        _this2.props.onChange({
          html: html,
          plainText: plainText
        });
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(editor) {
      this.props.onBlur(editor.getContent({
        format: 'text'
      }));
    }
  }, {
    key: "replaceUnderline",
    value: function replaceUnderline(content) {
      // this is necessary until the tinyMCE config is changed to accept <u> tags for
      // allready created lead-flows
      if (!content) {
        return content;
      }

      var replaced;
      replaced = content.replace(/<u>/g, '<span style="text-decoration: underline;">');
      replaced = replaced.replace(/<\/u>/g, '</span>');
      return replaced;
    }
  }, {
    key: "setIframeStyles",
    value: function setIframeStyles() {
      var iframe = this.getIframe();
      var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      var iframeBody = iframeDocument.body;
      var bodyHeight = iframeBody.offsetHeight; // necessary for the editor to grow with the content as draft does

      var adjust = bodyHeight >= THRESHOLD_HEIGHT ? 1 : 3;
      var bodyAdjustedHeight = bodyHeight + bodyHeight / 18 * adjust;
      var height = Math.max(bodyAdjustedHeight, MIN_HEIGHT);
      iframe.style.height = height + "px"; // also necessary until the configuration loads the correct styles

      iframeBody.style.fontFamily = '"Avenir Next W02", Helvetica, Arial, sans-serif';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          className = _this$props.className,
          disabled = _this$props.disabled,
          gates = _this$props.gates,
          scopes = _this$props.scopes,
          id = _this$props.id;
      return _react.default.createElement("div", {
        className: (0, _classNames.default)('rich-text-editor', className, {
          'rich-text-editor__disabled': disabled
        }),
        id: id
      }, _react.default.createElement(_reactTinymce.default, {
        config: (0, _leadFlows.getConfig)({
          minHeight: MIN_HEIGHT,
          gates: gates,
          scopes: scopes,
          appName: 'lead-flows',
          trackInteraction: _eventsTrackerUtils.trackEditorInteraction,
          pickerComponents: {
            EmojiPicker: AsyncEmojiPicker
          }
        }),
        content: (0, _TextEditorUtils.convertEmptySpaces)(this.replaceUnderline(this.props.contents)),
        onBlur: function onBlur(event, editor) {
          _this3.handleBlur(editor);
        },
        onChange: function onChange(event, editor) {
          _this3.handleEditorChange(editor);
        },
        onKeyUp: function onKeyUp(event, editor) {
          _this3.handleEditorChange(editor);
        },
        readOnly: disabled
      }));
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        contents: '',
        isEmail: false,
        onBlur: function onBlur() {}
      };
    }
  }]);
  return RichTextEditor;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    scopes: state.scopes.userScopes
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(RichTextEditor);

exports.default = _default;
module.exports = exports.default;